import Image from 'next/image';

export const FeatureLeftImgSection = ({
  redTitle,
  sectionTitle,
  imgSrc,
  imgAlt,
  textStructure,
}) => {
  return (
    <section id="features" className="w-full max-w-screen-lg mx-auto mt-[48px]">
      <h2 className="text-center text-[16px] font-light text-wtf-persianRed">
        {redTitle}
      </h2>

      <div className="flex flex-col gap-[48px] list-none p-0">
        <article className="flex flex-col items-center px-4 md:flex-row">
          <div className="w-320 shadow-darkRed max-w-80 h-120 relative overflow-hidden rounded-[16px] lg:mr-10">
            <img
              src={imgSrc}
              alt={imgAlt}
              width={328}
              height={120}
              className="rounded-[12px]"
            />
          </div>
          <div className="w-full md:w-1/2 md:px-4 lg:mx-0 text-wtf-white">
            <h3 className="ml-0 text-3xl font-bold m-[20px]">{sectionTitle}</h3>
            {textStructure}
          </div>
        </article>
      </div>
    </section>
  );
};
